import { useRouter } from 'next/router'

import { AppRoutes } from '@constants/app-routes'

import { StyledLink, StyledButton } from './styles'

export function SquareButton({
  id,
  label,
  backgroundColor = 'primary',
  backgroundColorOnHover = 'silver',
  textColor = 'white',
  textColorOnHover = 'white',
  path = AppRoutes.letsWork,
  width = '250px',
  marginTop,
  back,
  ...buttonsProps
}) {
  const router = useRouter()

  const goBack = () => {
    router.back()
  }

  return back ? (
    <StyledButton
      className="button-solution"
      id={id}
      width={width}
      $backgroundColor={backgroundColor}
      $backgroundColorOnHover={backgroundColorOnHover}
      $textColor={textColor}
      $textColorOnHover={textColorOnHover}
      $marginTop={marginTop}
      onClick={goBack}
      {...buttonsProps}
    >
      {label}
    </StyledButton>
  ) : (
    <StyledLink
      className="button-solution"
      id={id}
      width={width}
      $backgroundColor={backgroundColor}
      $backgroundColorOnHover={backgroundColorOnHover}
      $textColor={textColor}
      $textColorOnHover={textColorOnHover}
      href={path}
      $marginTop={marginTop}
      {...buttonsProps}
    >
      {label}
    </StyledLink>
  )
}
